import ClassListResourceModel from '../../generated/types/model/resource/ClassListResourceModel';
import ISchedulerListEntry from '../interfaces/ISchedulerListEntry';
import BaseSchedulerListEntryMixin from '../mixin/BaseSchedulerListEntryMixin';

export default class ClassListResourceViewModel extends BaseSchedulerListEntryMixin(ClassListResourceModel) implements ISchedulerListEntry {
  protected transformToDTO() {}

  protected transformFromDTO() {}
}
